import {enUS} from '../locales/en-US';
import {ptBR} from '../locales/pt-BR';
import {esES} from '../locales/es-ES';

import {getLocaleKeycloak} from '../utils/keycloak';
import { isEmptyObject } from "jquery";


const locales:any=[
    {locale:'es', message:esES},
    {locale:'pt-BR', message:ptBR},
    {locale:'en', message:enUS}
]

export const getLanguage = () =>{
    const localeKeycloak= getLocaleKeycloak();
    const locale=locales.find((loc:any)=>loc.locale===localeKeycloak);
    return isEmptyObject(locale) ? {locale:'es', message:esES}:locale;
}
